export default __webpack_public_path__ + "static/media/IMG_3808 copie.2d4fd1e6.jpg";